import React from 'react';
import { useFormContext } from 'react-hook-form';
import { AddTagFormData } from '../types';
import { FormToggle } from '../components/FormToggle';
import {
  SAMPLE_DETAILS_FIELDS,
  SAMPLE_DETAILS_DESCRIPTIONS,
} from '../constants';

export function SampleDetailsSection() {
  const { control } = useFormContext<AddTagFormData>();

  return (
    <div className="rounded-xl border border-neutral-200 shadow-sm p-5 space-y-4">
      <div className="space-y-3">
        <h3 className="text-sm font-medium text-gray-900">
          Sample Details
          <span className="text-danger-700 ml-3">*</span>
        </h3>

        <p className="text-xs" style={{ color: '#6E6E6E' }}>
          {SAMPLE_DETAILS_DESCRIPTIONS.FN_EXCLUSIVE}
        </p>
        <p className="text-xs" style={{ color: '#6E6E6E' }}>
          {SAMPLE_DETAILS_DESCRIPTIONS.FIT_SAMPLE}
        </p>

        <div className="space-y-2">
          {SAMPLE_DETAILS_FIELDS.map((field) => (
            <div key={field.name} className="flex items-center gap-4">
              <span className="text-sm font-medium text-gray-700 w-24">
                {field.label}
              </span>
              <FormToggle
                name={field.name}
                control={control}
                options={field.options}
                rules={{
                  validate: (value) =>
                    value !== undefined ||
                    `Please select ${field.label} or not`,
                }}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
